
import { Vue } from 'vue-property-decorator'

export default class extends Vue {}
